<template>
  <div class="column">
    <div class="card" style="margin-top:2px; height: 734px;">
      <div class="card-header">
        <div class="container pec-header">
          <div id="headtext2">{{ getKpiProcessExcellenceKpiName }}</div>
          <compareitem id="headkpi"
                       :overallByWave="getOverallByWave"
                       :kpi="getKpiProcessExcellence"></compareitem>
        </div>
      </div>

      <div class="card-body col-15">

        <div class="il-table">
          <div class="il-row col-15" >
            <!-- Cluster 1 -->
            <div class="il-cell col-3">
              <bmwmtableitem :overallByWave="getOverallByWave"
                             :kpi="getKpiContact"
                             :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <bmwmtableitem :kpi="getKpiAutoResponse"
                               :overallByWave="getOverallByWave"
                               :hasStar="true" />

                <bmwmtableitem :kpi="getKpiPersonalResponse4hrs"
                               :overallByWave="getOverallByWave"
                               :hasStar="true" />

                <bmwmtableitem :kpi="getKpiPersonalResponse2days"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="true" />

                <div class="subitemlostleadsstyle" id="dimmedout">
                  <bmwmtableitem :kpi="getKpiLostLeads"
                                :overallByWave="getOverallByWave"
                                :monochrome="true" />
                </div>

                <bmwmtableitem :kpi="getKpiQualityOfResponseStandards"
                               :overallByWave="getOverallByWave"
                               :hasStar="true" />

                <bmwmtableitem :kpi="getKpiAttemptAppointment"
                               :overallByWave="getOverallByWave"
                               :hasStar="true" />

                <!-- KPI38 -->
                <bmwmtableitem :kpi="getKpiAnswerRefersToEnquiry"
                               :overallByWave="getOverallByWave"
                               :hasStar="false" />
              </div>

            </div>

            <!-- Cluster 2 -->
            <div class="il-cell  col-3">

              <bmwmtableitem :kpi="getSalesConsultation"
                             :overallByWave="getOverallByWave"
                             :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <bmwmtableitem :kpi="getKpiVehiclePresentation"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="true" />

                <div  id="dimmedout">
                  <bmwmtableitem :kpi="getKpiEnquiryReference"
                                :overallByWave="getOverallByWave"
                                :monochrome="true" />
                </div>

                <!-- KPI38 -->
                <bmwmtableitem :kpi="getKpiWelcomeToTheDealership"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="false" />

                <bmwmtableitem :kpi="getKpiNeedAnalysis"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="false" />

                <bmwmtableitem :kpi="getKpiConfigurationAssistance"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="false" />

                <bmwmtableitem :kpi="getKpiUseOfPhysicalVehicleVirtualTool"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="false" />

                <bmwmtableitem :kpi="getKpiProvisionofProductInformation"
                               :overallByWave="getOverallByWave"
                               :hasDashBorder="false" />
              </div>

            </div>

            <!-- Cluster 3 -->
            <div class="il-cell  col-3">

              <bmwmtableitem :kpi="getKpiTestDrive"
                             :overallByWave="getOverallByWave"
                             :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <bmwmtableitem :kpi="getKpiTestDriveOffer"
                               :overallByWave="getOverallByWave"
                               :hasStar="true"
                               :hasDashBorder="true" />

                <!-- KPI38 -->
                <bmwmtableitem :kpi="getKpiTDProcedureRequirements"
                               :overallByWave="getOverallByWave"
                               :hasStar="false"
                               :hasDashBorder="false" />

                <bmwmtableitem :kpi="getKpiConditionOfTDVehicle"
                               :overallByWave="getOverallByWave"
                               :hasStar="false"
                               :hasDashBorder="false" />
              </div>
              <!-- Unterschied zw. "03. Test Drive Offer" und "06. Test Drive Offer"?
              <bmwmtableitem :kpi="dashdata.KPI[16]" :hasStar="true"></bmwmtableitem>-->

            </div>

            <!-- Cluster 4 -->
            <div class="il-cell  col-3">

              <bmwmtableitem :kpi="getKpiOffer"
                             :overallByWave="getOverallByWave"
                             :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">
                <bmwmtableitem :kpi="getKpiRetailLeadDoc"
                               :overallByWave="getOverallByWave"
                               :hasStar="true" />

                <bmwmtableitem :kpi="getKpiFinancingProductOffer"
                               :overallByWave="getOverallByWave"
                               :hasStar="true" />

                <bmwmtableitem :kpi="getKpiNewCarOffer"
                               :overallByWave="getOverallByWave"
                               :hasStar="true"
                               :hasDashBorder="true" />

                <!-- KPI38 -->
                <bmwmtableitem :kpi="getKpiProvisionOfPriceInformation"
                               :overallByWave="getOverallByWave"
                               :hasStar="false"
                               :hasDashBorder="false" />
              </div>
            </div>

            <!-- Cluster 5 -->
            <div class="il-cell  col-3">

              <bmwmtableitem :kpi="getKpiFollowUp"
                             :overallByWave="getOverallByWave"
                             :isHeader="true" />
              <titleunderline />

              <div class="dash-card-inner">

              <!-- Unterschied zw. "05. Follow-up on Offer" und "09. Follow-up on Offer"? -->
                <bmwmtableitem :kpi="getKpiFollowUpOnOffer"
                               :overallByWave="getOverallByWave"
                               :hasStar="true"
                               :hasDashBorder="true" />

                <div id="dimmedout">
                  <bmwmtableitem :kpi="getKpiFollowUpByPhone48h"
                                :overallByWave="getOverallByWave"
                                :monochrome="true" />

                  <bmwmtableitem :kpi="getKpiFollowUpByPhone24h"
                                :overallByWave="getOverallByWave"
                                :monochrome="true" />
                </div>

                <!-- KPI38 -->
                <bmwmtableitem :kpi="getKpiCourtesyTextMessage"
                               :overallByWave="getOverallByWave"
                               :monochrome="false" />

                <bmwmtableitem :kpi="getKpiAskingForDecision"
                               :overallByWave="getOverallByWave"
                               :monochrome="false" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import CustomKpiSorting from '@/mixins/CustomKpiSorting'

  import compareitem from './CompareItem'
  import bmwmtableitem from './BMWMTableItem.vue'
  import titleunderline from './TitleUnderline'
  // import WideNscItem from './WideNscItem.vue'

  export default {
    name: 'BMWMProcessExcellenceColumn',

    mixins: [ CustomKpiSorting ],

    data: function(){
      return {
        kpi1 : {}
      }
    },

    components: {
      compareitem,
      bmwmtableitem,
      titleunderline,
      // WideNscItem
    },

    props:[
      'dashdata',
      'isBmwM'
    ],

    methods:{
      getKpiByString(name) {
        //   if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0)
        //     return _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0)
        {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          return this.getOrderedKpi(item)
        }
      },
      getKpiGroupByString(name) {
        // if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
        //   return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name)
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
        {
          let item = _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name)
          return this.getOrderedKpi(item)
        }
      },
    },

    computed: {

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getKpiProcessExcellence: function () {
        return this.getKpiGroupByString('Process Excellence')
      },

      isKpiProcessExcellenceVisible: function () {
        var _kpi = this.getKpiProcessExcellence
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result =  _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      getKpiProcessExcellenceKpiName: function() {
        var item = this.getKpiProcessExcellence
        if (item) {
          return item.KpiName
        }
      },

      // Cluster 1: Contact Column
      getKpiContact: function() {
        return this.getKpiByString('01. Kontakt')
      },
      getKpiAutoResponse: function() {
        return this.getKpiByString('01. Automatische Eingangsbestätigung')
      },
      getKpiPersonalResponse4hrs: function() {
        return this.getKpiByString('02. Persönliche Rückmeldung innerhalb von 4h')
      },
      getKpiPersonalResponse2days: function() {
        return this.getKpiByString('01. Persönliche Antwort innerhalb von 2 Werktagen')
      },
      getKpiLostLeads: function() {
        return this.getKpiByString('Lost Leads')
      },
      getKpiQualityOfResponseStandards: function() {
        return this.getKpiByString('03. Qualität der Antwort: Standards')
      },
      getKpiAttemptAppointment: function() {
        return this.getKpiByString('04. Qualität der Antwort: Nächste Schritte')
      },
      getKpiAnswerRefersToEnquiry: function() {
        return this.getKpiByString('1.5 Antwortbezug auf Anfrage') // 1.5 Answer refers to enquiry') // 36/43 kpi
      },

      // Cluster 2: Sales Consultation Column
      getSalesConsultation: function() {
        return this.getKpiByString('02. Beratungsgespräch')
      },
      getKpiVehiclePresentation: function() {
        return this.getKpiByString('02. Fahrzeugpräsentation')
      },
      getKpiEnquiryReference: function() {
        return this.getKpiByString('Enquiry Reference')
      },
      getKpiWelcomeToTheDealership: function() {
        return this.getKpiByString('2.1 Begrüßung beim Händler') // 2.1 Welcome to the dealership') // 36/43 kpi
      },
      getKpiNeedAnalysis: function() {
        return this.getKpiByString('2.2 Bedarfsanalyse') // 2.2 Need analysis') // 36/43 kpi
      },
      getKpiConfigurationAssistance: function() {
        return this.getKpiByString('2.3 Unterstützung Konfiguration') // 2.3 Configuration assistance') // 36/43 kpi
      },
      getKpiUseOfPhysicalVehicleVirtualTool: function() {
        return this.getKpiByString('2.5 Nutzung phys. Fzg/virtuelles Tool') // 2.5 Use of phyical vehicle/virtual tool') // 36/43 kpi
      },
      getKpiProvisionofProductInformation: function() {
        return this.getKpiByString('2.6 Angebot von Produktinformationen') // 2.6 Provision of product information') // 36/43 kpi
      },

      // Cluster 3: Test Drive Column
      getKpiTestDrive: function() {
        return this.getKpiByString('03. Probefahrt')
      },
      getKpiTestDriveOffer: function() {
        return this.getKpiByString('03. Probefahrt aktiv angeboten')
      },
      getKpiTDProcedureRequirements: function() {
        return this.getKpiByString('3.2 PF Anforderungen') // 3.2 TD procedure requirements') // 36/43 kpi
      },
      getKpiConditionOfTDVehicle: function() {
        return this.getKpiByString('3.3 Zustand des PF-Fahrzeugs') // 3.3 Condition of TD vehicles') // 36/43 kpi
      },

      // Cluster 4: Offer Column
      getKpiOffer: function() {
        return this.getKpiByString('04. Angebot')
      },
      getKpiRetailLeadDoc: function() {
        return this.getKpiByString('05. Interessentenkontakt dokumentiert')
      },
      getKpiFinancingProductOffer: function() {
        return this.getKpiByString('08. Finanzprodukt aktiv angeboten')
      },
      getKpiNewCarOffer: function() {
        return this.getKpiByString('04. Neufahrzeugangebot aktiv überreicht')
      },
      getKpiProvisionOfPriceInformation: function() {
        return this.getKpiByString('4.2 Angebot von Preisinformationen') // 4.2 Provision of price information') // 36/43 kpi
      },

      // Cluster 5: FollowUp Column
      getKpiFollowUp: function() {
        return this.getKpiByString('05. Nachkontakt')
      },
      getKpiFollowUpOnOffer: function() {
        return this.getKpiByString('05. Nachkontakt in 48 Stunden\/5 Tagen')
      },
      getKpiFollowUpByPhone24h: function() {
        return this.getKpiByString('Follow-up via phone (48h)')
      },
      getKpiFollowUpByPhone48h: function() {
        return this.getKpiByString('Follow-up via phone (24h)')
      },
      getKpiCourtesyTextMessage: function() {
        return this.getKpiByString('5.1 Dankeschön Textnachricht') // 5.1 Courtesy text message') // 36/43 kpi
      },
      getKpiAskingForDecision: function() {
        return this.getKpiByString('5.6 Entscheidungsnachfrage') // 5.6 Asking for decision') // 36/43 kpi
      }
    }
  }

</script>

<style scoped>

  #headtext2 {
    height: 24pt;
    text-align: center;
    color: #111111;
    position: relative;
    top: -6px;
    display: inline-block;
    font-weight: 500;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

  .column {
    margin: 0px;
    padding: 0px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 0px;
  }

  .subitem{
    margin-inline-start: 6px;
    margin-inline-end: 6px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  .subitemlostleadsstyle {
    margin-inline-start: 36px;
    margin-inline-end: 6px;
    margin-block-start: 2px;
    margin-block-end: 2px;
  }

  .col-3{
    padding-left: 0px;
    padding-right: 0px;

    margin-left: 0px;
    margin-right: 0px;
    border-width: 0px;
  }

  .card-header:first-child {
    border-radius: 0px;
    margin: 0px;
    padding: 0px;
  }

  .card-header {
    background: #d9d9d9;
    border-width: 0px;
    margin: 0px;
    height: 40px;
  }

  .pec-header {
    margin-left: 25%;
    margin-left: 20%;
    margin-right: 20%;
    width: 750px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .card-body {
    padding: 0px;
    margin: 0px;
  }

  .card {
    border: solid #bfbfbf;
    border-width: 2px;
    border-radius: 0rem;

    margin-top: 2px;

    /* margin: 0px; */
    padding: 0px;
    padding-left: 44px;
    height:697px;
  }

  .il-table{
    font-size: 9pt;
    font-size-adjust: inherit;
    height: fit-content;
    width: 100%;
    display: table;
  }

  .il-row {
    width: 100%;
    float: left;
  }

  #dimmedout {
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .il-cell {
    float: left;
    width: 20%;
    text-overflow: ellipsis;
    display: table-cell;
  }

  .pec-card{
    float: left;
  }

  .card {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding: 0px;
  }

  h3{
    height: 36pt;
    line-height: 28pt;
    text-align: center;
    float: left;
    top: 0px;
    font-size: 16pt;
    font-stretch: extra-condensed;
  }

</style>
